import React, { Suspense, lazy } from 'react'
import { WhatsAppContext, WhatsAppContextProps } from 'components/WhatsAppButton/WhatsAppContext'
import { Loading, NavBar, RootBackgroundImage } from 'components/index'
import { Script } from 'gatsby-script'

const Footer = lazy(() => import('components/Footer'))

export interface LayoutProps {
  children: React.ReactNode
  disableWhatsApp?: boolean
  disableDefaultHeader?: boolean
  disableFooterContact?: boolean
  whatsAppContextValue?: WhatsAppContextProps
}

export const Layout = ({
  children,
  disableWhatsApp,
  disableDefaultHeader,
  disableFooterContact,
  whatsAppContextValue = {},
}: LayoutProps) => {
  return (
    <WhatsAppContext.Provider value={whatsAppContextValue}>
      <RootBackgroundImage>
        <NavBar disableWhatsApp={disableWhatsApp} disableDefaultHeader={disableDefaultHeader} />
        <div>{children}</div>
        <Suspense fallback={<Loading />}>
          <Footer disableFooterContact={disableFooterContact} />
        </Suspense>
      </RootBackgroundImage>
    </WhatsAppContext.Provider>
  )
}

export default Layout
